import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import EInput, { EButton } from 'src/Components/EInput';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { UserStore } from 'src/Stores/User/UserStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { ICategory } from '../../../../Interfaces/AdminInterface';
import DataService from '../../../../Services/Data';
import DataTable from '../../../DataTable';

interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class AdminCategories extends React.Component {
    public props: any;
    public adminStore: any;
    public categoriesDisposer: any; 
    public categories: ICategory[] = [];
    public categoryList: IList;
    public dataService: any = new DataService();
    private UserStore: UserStore;
    private MessageStore: MessageStore;

    private tableHeaders: any[] = [
        { content: 'Category', 'class': 'align-left' },
        { content: 'Description', 'class': 'align-left' }
    ];


    public state = {
        categories: this.categories,
        category: new ICategory(),
        categoryModalOpen: false,
    };

    constructor(props: any) {
        super(props);
        this.UserStore = props.stores.UserStore;
        this.adminStore = props.stores.AdminStore;
        this.MessageStore = props.stores.MessageStore;
    }

    public componentDidMount() {

        this.createDisposers();

        this.adminStore.getCategories();
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.categoriesDisposer = intercept(this.adminStore, 'categories', (change: any) => {
            let data = change.newValue;

            data = this.dataService.sort(data, { name: 'asc' });

            this.setState({
                categories: data
            });

            this.formatDataTable();

            return change;
        });
    }

    public clearDisposers() {
        this.categoriesDisposer();
    }

    public toggleCategoryModal = () => {
        this.setState({
            category: new ICategory(),
            categoryModalOpen: !this.state.categoryModalOpen,
            rowIndex: 0,
        });
    }

    public addAnother = () => {
        this.handleSaveCategory();
        this.setState({
            category: new ICategory(),
        });
    }

    public handleSave = () => {
        this.handleSaveCategory();
        this.setState({
            category: new ICategory(),
            categoryModalOpen: false,
        });
    }

    public handleSaveCategory = () => {
        this.adminStore.saveCategory(this.state.category)
            .then(
                (data: any) => {
                    if (data) {
                        const message = 'Changes have been saved';
                        this.MessageStore.addMessage(
                            message,
                            'success'
                        );
                        this.adminStore.getCategories();
                    }
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public removeCategory = (index: number) => {
        const category = this.state.categories[index];
        this.adminStore.deleteCategory(category)
            .then(
                (data: any) => {
                    if (data) {
                        this.MessageStore.addMessage(
                            'Category Successfully Deleted',
                            'success'
                        );
                        this.adminStore.getCategories();
                    }
                }
            );
    }

    public onEdit = (index: number) => {
        this.setState({
            category: DeepCopy(this.state.categories[index]),
            categoryModalOpen: true,
        });
    }

    public handleChange = (event: any) => {
        const category = this.state.category;

        category[event.target.name] = event.target.value;

        this.setState({
            category,
            isDirty: true
        });
    }


    public formatDataTable() {
        const rows = this.state.categories.map((category: ICategory, index: number) => {
            return [
                {
                    content: category.name,
                },
                {
                    'class': 'align-left',
                    content: category.description
                }
            ];
        });
        return {
            headers: this.tableHeaders,
            rows
        };
    }

    public render() {
        return(
            <div>
                <Row className="header">
                    <Col md="6">
                        <h1 className="float-left">Categories</h1>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <DataTable
                            list={this.formatDataTable()}
                            onNew={('Permissions.Admin.Categories.Create') && {
                                callback: this.toggleCategoryModal,
                                text: 'Add New Category'
                            }}
                            onEdit={this.UserStore.hasPermission('Permissions.Admin.Categories.Update') ? this.onEdit : undefined}
                            onDelete={this.UserStore.hasPermission('Permissions.Admin.Categories.Delete') ? this.removeCategory : undefined}
                        />
                    </Col>
                </Row>
                <Modal isOpen={this.state.categoryModalOpen} toggle={this.toggleCategoryModal}>
                    <ModalHeader toggle={this.toggleCategoryModal}>
                        Add/Edit Category
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md="6">
                                <FormGroup className="required">
                                    <Label>Name</Label>
                                    <EInput
                                        type="text"
                                        name="name"
                                        required={true}
                                        value={this.state.category.name}
                                        onChange={this.handleChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label>Description</Label>
                                    <EInput
                                        type="textarea"
                                        name="description"
                                        value={this.state.category.description}
                                        onChange={this.handleChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleCategoryModal}>Cancel</Button>
                        <EButton color="primary" onClick={this.handleSave}>Save Category</EButton>
                        <EButton color="primary" onClick={this.addAnother}>Add Another</EButton>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default AdminCategories;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Categories/AdminCategories.tsx